module.exports = __webpack_public_path__ + "static/media/credit.381d5652.svg";